import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { defer } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { Observable } from 'rxjs';

@Injectable()
export class ReqTimeInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return defer(() => {
      const key = req.url;
      console.time(key);
      return next.handle(req).pipe(finalize(() => {
        console.timeEnd(key);
      })
      );
    });
  }
}
